import type { FC } from "react";
import { Spinner } from "../../common/Spinner";

interface Props {
	lower: number | undefined;
	upper: number | undefined;
	audienceLower?: number;
	audienceUpper?: number;
	isLoading: boolean;
	hasTargeting: boolean;
}

export const AudienceEstimate: FC<Props> = ({
	lower,
	upper,
	audienceLower,
	audienceUpper,
	isLoading,
	hasTargeting,
}) => {
	if (!hasTargeting) {
		return (
			<div style={{ fontSize: 13 }} className="text-muted">
				Add locations to see estimated reach.
			</div>
		);
	}

	if (isLoading) {
		return (
			<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
				<Spinner size={16} />
				<span style={{ fontSize: 13 }}>Estimating reach...</span>
			</div>
		);
	}

	if (lower === undefined || upper === undefined) {
		return null;
	}

	const fmt = (n: number) => n.toLocaleString();

	return (
		<div>
			{audienceLower !== undefined && audienceUpper !== undefined && (
				<div style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>
					Estimated audience: {fmt(audienceLower)} &ndash; {fmt(audienceUpper)}
				</div>
			)}
			<div style={{ fontSize: 13, fontWeight: 500 }}>
				Estimated daily reach: {fmt(lower)} &ndash; {fmt(upper)}
			</div>
			{upper < 1000 && (audienceUpper ?? 0) < 1000 && (
				<div className="text-warning" style={{ fontSize: 12, marginTop: 4 }}>
					Audience may be too small for effective delivery.
				</div>
			)}
			{upper < 1000 && (audienceUpper ?? 0) >= 1000 && (
				<div className="text-muted" style={{ fontSize: 12, marginTop: 4 }}>
					Meta has not provided a daily reach forecast for this setup yet.
				</div>
			)}
			{lower > 100000 && (
				<div className="text-info" style={{ fontSize: 12, marginTop: 4 }}>
					Consider narrowing your targeting for better results.
				</div>
			)}
		</div>
	);
};
